<template>
  <div class="review-modal">
    <div class="booking-requested">
      <a
        data-w-id="caac9a15-5baa-ef5a-3411-d43737a55cc4"
        href="#"
        class="link-block-5 w-inline-block"
      >
        <img
          @click="cancel"
          src="@/assets/timeslot-images/cancel.svg"
          loading="lazy"
          alt=""
        />
      </a>
      <div class="div-block-86-active">
        <img
          :src="
            bookingToBeReviewed.professionalProfilePicture ||
              require('@/assets/timeslot-images/profileImg.svg')
          "
          loading="lazy"
          class="prof-image"
          alt=""
        />
      </div>
      <div class="div-block-52">
        <h1 class="modal-heading">Drop a review</h1>
      </div>
      <p class="paragraph-7">
        What are the highlights of your mentoring session with
        <!--        <strong>{{ profName }}</strong-->
        <strong>{{ bookingToBeReviewed.professionalName }}</strong>
        ?
      </p>
      <div class="rating-link-wrapper">
        <a href="#" class="rating-card w-inline-block">
          <img
            src="@/assets/timeslot-images/Star-Active.svg"
            loading="lazy"
            alt=""
          />
          <!--          <img src="@/assets/timeslot-images/Star-Inactive.svg" loading="lazy" alt="" v-else>-->
        </a>
        <a href="#" class="rating-card w-inline-block" @click="toggleStar2">
          <img
            src="@/assets/timeslot-images/Star-Active.svg"
            loading="lazy"
            alt=""
            v-if="star2"
          />
          <img
            src="@/assets/timeslot-images/Star-Inactive.svg"
            loading="lazy"
            alt=""
            v-else
          />
        </a>
        <a href="#" class="rating-card w-inline-block" @click="toggleStar3">
          <img
            src="@/assets/timeslot-images/Star-Active.svg"
            loading="lazy"
            alt=""
            v-if="star3"
          />
          <img
            src="@/assets/timeslot-images/Star-Inactive.svg"
            loading="lazy"
            alt=""
            v-else
          />
        </a>
        <a href="#" class="rating-card w-inline-block" @click="toggleStar4">
          <img
            src="@/assets/timeslot-images/Star-Active.svg"
            loading="lazy"
            alt=""
            v-if="star4"
          />
          <img
            src="@/assets/timeslot-images/Star-Inactive.svg"
            loading="lazy"
            alt=""
            v-else
          />
        </a>
        <a href="#" class="rating-card w-inline-block" @click="toggleStar5">
          <img
            src="@/assets/timeslot-images/Star-Active.svg"
            loading="lazy"
            alt=""
            v-if="star5"
          />
          <img
            src="@/assets/timeslot-images/Star-Inactive.svg"
            loading="lazy"
            alt=""
            v-else
          />
        </a>
      </div>
      <div class="textfield-review">
        <div class="div-block-187">
          <textarea
            placeholder="Write a review"
            maxlength="5000"
            id="field-4"
            name="field-4"
            data-name="field"
            class="review-textfield w-input"
            v-model="reviewModel.comment"
          ></textarea>
        </div>
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div
        v-else
        data-w-id="caac9a15-5baa-ef5a-3411-d43737a55cdc"
        class="button-15 w-button"
        @click="addReview"
      >
        Drop review
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BookingRequest from "@/model/requests/BookingRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";

export default {
  name: "ReviewModal",
  components: { BaseComponentLoader },
  data() {
    return {
      star1: true,
      star2: false,
      star3: false,
      star4: false,
      star5: false,
      reviewModel: BookingRequest.updateReview
    };
  },
  computed: {
    ...mapState({
      singleProfessional: state => state.professional.singleProfessional,
      userInfo: state => state.auth.userInfo,
      bookingToBeReviewed: state => state.booking.bookingToBeReviewed
    }),
    rating() {
      let value = 0;
      if (this.star1) {
        value++;
      }
      if (this.star1 && this.star2) {
        value++;
      }
      if (this.star1 && this.star2 && this.star3) {
        value++;
      }
      if (this.star1 && this.star2 && this.star3 && this.star4) {
        value++;
      }
      if (this.star1 && this.star2 && this.star3 && this.star4 && this.star5) {
        value++;
      }
      return value;
    },
    ...mapState(["loader"])
  },
  props: {
    cancel: Function,
    buttonAction: Function,
    profName: String
  },
  methods: {
    toggleStar1() {
      this.star1 = !this.star1;
    },
    toggleStar2() {
      this.star2 = !this.star2;
      if (!this.star2) {
        this.star5 = false;
        this.star4 = false;
        this.star3 = false;
      }
    },
    toggleStar3() {
      this.star3 = !this.star3;
      if (this.star3) {
        this.star2 = true;
      }
      if (!this.star3) {
        this.star5 = false;
        this.star4 = false;
      }
    },
    toggleStar4() {
      this.star4 = !this.star4;
      if (this.star4) {
        this.star2 = true;
        this.star3 = true;
      }
      if (!this.star4) {
        this.star5 = false;
      }
    },
    toggleStar5() {
      this.star5 = !this.star5;
      if (this.star5) {
        this.star2 = true;
        this.star3 = true;
        this.star4 = true;
      }
    },
    addReview() {
      this.reviewModel.rating = this.rating;
      this.reviewModel.reviewerType = this.userInfo.userRole;
      this.reviewModel.reviewerId = this.userInfo.customerId;
      this.reviewModel.bookingId = this.bookingToBeReviewed.bookingId;
      StoreUtils.dispatch("booking/updateReview", this.reviewModel);
    }
  }
};
</script>

<style scoped>
.prof-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
</style>
